var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { keyframes } from '@emotion/react';
// Const variables used to calculate max height for scrolling
var TITLE_CONTAINER_HEIGHT = 54;
var PADDING_AROUND_DIALOG = 40;
export var getDialogUnderlaySx = function () {
    return {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        position: 'fixed',
        zIndex: 'pageCover',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
};
export var getDialogSx = function (isOpen, isStatic, widthSet) {
    var startingTranslation = 'translate(-50%, -100%)';
    var endingTranslation = 'translate(-50%, -50%)';
    var dialogFadeIn = keyframes({
        from: {
            opacity: 0,
            transform: startingTranslation,
        },
        to: {
            opacity: 1,
            transform: endingTranslation,
        },
    });
    var dialogFadeOut = keyframes({
        from: {
            opacity: 1,
            transform: endingTranslation,
        },
        to: {
            opacity: 0,
            transform: startingTranslation,
        },
    });
    return __assign(__assign({ fontFamily: 'inherit', borderRadius: 2, backgroundColor: 'white', position: isStatic ? 'relative' : 'fixed', zIndex: 'modal' }, (!widthSet && { width: 500 })), { maxHeight: "calc(100% - ".concat(PADDING_AROUND_DIALOG * 2, "px)"), maxWidth: "calc(100% - ".concat(PADDING_AROUND_DIALOG * 2, "px)"), top: isStatic ? 65 : '50%', left: isStatic ? 250 : '50%', boxShadow: 4, outline: 'none', opacity: isOpen ? 1 : 0, transform: endingTranslation, animation: isStatic
            ? ''
            : "".concat(isOpen ? dialogFadeIn : dialogFadeOut, " 0.3s ease-out") });
};
export var getDialogTitleSx = function () {
    return {
        backgroundColor: 'black',
        padding: '15px 30px',
        borderRadius: 2,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        minHeight: TITLE_CONTAINER_HEIGHT,
        lineHeight: 'solid',
        display: 'flex',
        alignItems: 'center',
    };
};
export var getDialogTitleTextSx = function () {
    return {
        marginRight: 'auto',
        fontSize: 2,
        fontWeight: 4,
        color: 'white',
        display: 'flex',
    };
};
export var getDialogDismissButtonSx = function () {
    return {
        fontSize: 4,
        backgroundColor: 'transparent',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        margin: 0,
        padding: 0,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
    };
};
export var getDialogBodySx = function (overflowY, dialogHeight) {
    // By default the max height is calculated using the padding of the dialog
    // and the height of the title container in relations to the max height of the view port.
    var maxHeight = "calc(100vh - ".concat(PADDING_AROUND_DIALOG * 2 + TITLE_CONTAINER_HEIGHT, "px)");
    if (dialogHeight) {
        dialogHeight = dialogHeight.replace('px', '');
        // Max height of the dialog body is the difference
        // between the height of the dialog and the height of the title container.
        maxHeight = "".concat(+dialogHeight - TITLE_CONTAINER_HEIGHT, "px");
    }
    return {
        padding: 5,
        maxHeight: maxHeight,
        display: 'block',
        overflowY: overflowY,
    };
};
